import React, { useState } from "react";
import { useAppDispatch } from "../../../../redux/hooks";

import TextInput from "../../../../components/misc/TextInput";
import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import CustomButton from "../../../../components/CustomButton";
import Text from "../../../../styleguide/Text";
import { DevicesNomenclatureListInterface } from "../../../../redux/interfaces/admin.interface";
import { deleteOrRestoreDevice } from "../../../../redux/api/admin.api";

interface OriginalDeviceProps {
  itemId: string;
  crudData: DevicesNomenclatureListInterface;
  tableContext: any;
}

interface ToggleModalProps {
  handleShowToggleModal: (params: {
    device: DevicesNomenclatureListInterface;
    tableContext: any;
  }) => void;
}

function withToggleStatusModal<P extends OriginalDeviceProps>(
  WrappedComponent: React.ComponentType<P & ToggleModalProps>,
) {
  function ToggleStatusModal(props: P) {
    const dispatch = useAppDispatch();

    const [isLoadingSave, setIsLoadingSave] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const [deviceSelected, setDeviceSelected] =
      useState<DevicesNomenclatureListInterface | null>(null);

    const [tableContext, setTableContext] = useState<any | null>(null);
    const [observatii, setObservatii] = useState<string | number | null>("");

    const handleShowToggleModal = ({
      device,
      tableContext: context,
    }: {
      device: DevicesNomenclatureListInterface;
      tableContext: any;
    }) => {
      setShowModal(true);
      setDeviceSelected(device);
      setTableContext(context);
      setObservatii("");
    };

    const handleCloseModal = () => {
      setShowModal(false);
      setDeviceSelected(null);
      setTableContext(null);
      setObservatii("");
      setIsLoadingSave(false);
    };

    const handleToggleStatus = async () => {
      if (!deviceSelected || !tableContext) {
        return;
      }

      setIsLoadingSave(true);

      await dispatch(
        deleteOrRestoreDevice({
          idDevice: deviceSelected.id_echipamente.toString(),
          observatii: observatii,
          tableContext: {
            ...tableContext.tableSearch,
            page: tableContext.tablePagination.page,
            per_page: tableContext.tablePagination.rowsPerPage,
          },
        }),
      );

      handleCloseModal();
    };

    if (!deviceSelected) {
      return (
        <WrappedComponent
          {...(props as P)}
          handleShowToggleModal={handleShowToggleModal}
        />
      );
    }

    const isCurrentlyStatusTwo = deviceSelected.status === 2;
    const modalAction = isCurrentlyStatusTwo ? "Activare" : "Casare";
    const modalActionText = isCurrentlyStatusTwo ? "activați" : "casați";

    return (
      <>
        <ModalWrapper
          title={`${modalAction} Dispozitiv: ${deviceSelected?.model}`}
          show={showModal}
          handleClose={handleCloseModal}>
          <div className="mb-4">
            <Text variant="body1" className="mb-3">
              Doriti sa <span className="font-bold">{modalActionText}</span>{" "}
              echipamentul{" "}
              <span className="font-bold">{deviceSelected.model}</span> ?
            </Text>

            <TextInput
              label="Motive"
              placeholder=""
              name="observatii"
              id="observatii"
              value={observatii}
              onChange={(value) => setObservatii(value)}
            />
          </div>

          <div className="flex justify-between">
            <CustomButton
              variant="outlined"
              onClick={handleCloseModal}
              className="mr-2">
              Anulează
            </CustomButton>
            <CustomButton
              variant="contained"
              onClick={handleToggleStatus}
              loading={isLoadingSave}
              disabled={isLoadingSave}
              color={isCurrentlyStatusTwo ? "primary" : "error"}>
              Confirmă {modalAction}
            </CustomButton>
          </div>
        </ModalWrapper>
        <WrappedComponent
          {...(props as P)}
          handleShowToggleModal={handleShowToggleModal}
        />
      </>
    );
  }
  return ToggleStatusModal;
}

export default withToggleStatusModal;
